export const BOARD_MESSAGE_CONSTANT = {
    INIT_MESSAGE: 'INIT_MESSAGE',
    SHOW_MESSAGE: 'SHOW_MESSAGE',
    HIDE_MESSAGE: 'HIDE_MESSAGE',
    TYPE_ERROR: 'error',
    TYPE_WARNING: 'warning',
    TYPE_SUCCESS: 'success',
    TYPE_CONFIRMATION: 'confirmation',
    TYPE_INFO: 'info',
    BOARD_ACTION_ERROR: 'Board Action Error :'
};